import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTermsAcceptance } from '../contexts/TermsAcceptanceContext';

const TermsAcceptanceModal = () => {
  const { showModal, latestTerms, acceptTerms } = useTermsAcceptance();
  const [checked, setChecked] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const location = useLocation();

  if (!showModal || !latestTerms || location.pathname === '/terms') return null;

  const handleAccept = async () => {
    if (!checked || isAccepting) return;
    setIsAccepting(true);
    await acceptTerms();
    setIsAccepting(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[100] p-4">
      <div
        className="rounded-xl border max-w-2xl w-full flex flex-col"
        style={{ backgroundColor: '#111827', borderColor: '#374151', maxHeight: '85vh' }}
      >
        {/* Header */}
        <div className="p-6 border-b flex-shrink-0" style={{ borderColor: '#374151' }}>
          <h2 className="text-xl font-bold text-white">Ενημερωμένοι Όροι Χρήσης</h2>
          <p className="text-gray-400 text-sm mt-1">
            Έκδοση {latestTerms.version} &mdash; Απαιτείται αποδοχή για να συνεχίσετε
          </p>
        </div>

        {/* Scrollable content */}
        <div className="p-6 overflow-y-auto flex-1">
          <div className="text-gray-300 text-sm leading-relaxed whitespace-pre-wrap">
            {latestTerms.content}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t flex-shrink-0 space-y-4" style={{ borderColor: '#374151' }}>
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-emerald-400 hover:text-emerald-300 text-sm transition-colors"
          >
            Διαβάστε τους πλήρεις Όρους Χρήσης εδώ
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
          <label className="flex items-start gap-3 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              className="mt-0.5 w-4 h-4 accent-emerald-500 cursor-pointer"
            />
            <span className="text-gray-300 text-sm">
              Διάβασα και αποδέχομαι τους Όρους Χρήσης
            </span>
          </label>
          <button
            onClick={handleAccept}
            disabled={!checked || isAccepting}
            className="w-full px-5 py-2.5 rounded-lg font-medium text-white transition-transform duration-200 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
            style={{ background: 'linear-gradient(90deg, #10B981, #059669)' }}
          >
            {isAccepting ? 'Αποθήκευση...' : 'Αποδοχή & Συνέχεια'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAcceptanceModal;
